module.exports = __webpack_public_path__ + "static/homepage-banner-mob-04d08cb61adb599a456dc8b4e4150e7c.png";